import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["tab", "panel"];
  static values = { defaultTab: String };

  connect() {
    if (this.defaultTabValue) {
      this._selectTab(this.defaultTabValue);
    } else {
      // If no default tab is set, hide all panels and disable all inputs.
      this.panelTargets.forEach((panel) => {
        panel.classList.add("vanish");
        this._enableOrDisableInputs(panel, false);
      })
    }
  }

  swichTab(event) {
    const selectedTabName = event.currentTarget.dataset.tabName;
    this._selectTab(selectedTabName);
  }

  _selectTab(selectedTabName) {
    // Update all triggers for active/inactive classes.
    this.tabTargets.forEach((tab) => {
      const isActive = tab.dataset.tabName === selectedTabName;
      tab.classList.toggle("active", isActive);
      tab.classList.toggle("inactive", !isActive);
    });

    // Hide/Show panels and enable/disable inputs accordingly.
    this.panelTargets.forEach((panel) => {
      const isVisible = panel.dataset.panel === selectedTabName;
      panel.classList.toggle("appear", isVisible);
      panel.classList.toggle("vanish", !isVisible);

      // Enable inputs in the active panel; disable them in inactive panels.
      this._enableOrDisableInputs(panel, isVisible);
    });
  }

  _enableOrDisableInputs(panel, isVisible) {
    panel.querySelectorAll("input, select, textarea").forEach((input) => {
      input.disabled = !isVisible;
    });
  }
}
